export const PRICELINE_MAP_ID = '538f74d0ecb7e24e';
export const GOOGLE_MAP_API_KEY = 'AIzaSyA3oQ_k-qetNGi1rYpeR2zlIoWQqczXnls';